import React from 'react';
import { reactLocalStorage } from 'reactjs-localstorage';
import { FaPhoneAlt } from 'react-icons/fa';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';

import Util from '../../util/Util';
import LeadConst from '../../util/LeadConst';
import Const from '../../util/Constants';
import CallAPI from '../../api/CallAPI';
import ApiUiController from '../../controller/ApiUiController';

class CloudCallPopup extends React.Component {

  constructor(props) {
    super(props);
    this.model = reactLocalStorage.getObject(Const.Model).call;
    this.state = { inValid: {}, inApiCall: false, phones: [] };
  }

  onMakeCall = phone => {
    this.setState({ ...this.state, inApiCall: true });
    CallAPI.cloudCall(phone, this.props.call, this.props.modelNo, this.props.modelId, this.onSaved, this.onFail);
  }

  onFail = msg => {
    msg = msg && msg.message ? msg.message : msg;
    Util.showNotification('Failed', msg ? msg : 'Cloud Call unsuccessfully', 'danger');
    this.setState({ ...this.state, inApiCall: false });
  }
  onSaved = call => {
    this.setState({ ...this.state, inApiCall: false });
    this.props.onHide();
    if(this.props.addCall) {
      this.props.addCall(call, LeadConst.Call);
    }
  }

  render() {
    let phones = this.props.data && this.props.data.phone ? this.props.data.phone : '';
    phones = phones.length > 2 ? phones.substring(1, phones.length - 1).split(Const.Opt) : [];
    phones = phones.map(phone => phone.includes(Const.Hhn) ? phone.split(Const.Hhn)[1] : phone);
    phones = phones.map(phone => 
      <div key={`call_popup_${phone}`} className="col" onClick={() => this.onMakeCall(phone)}>
        <div className="form-group"><FaPhoneAlt /><label>{phone}</label></div>
      </div>
    );
    return (
      <Modal aria-labelledby="contained-modal-title-vcenter" size="md" show={this.props.show}
        onHide={this.props.onHide} centered onExit={() => this.isAPICalled = false }>
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">Make Call</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form>
            <ApiUiController inApiCall={this.state.inApiCall}> 
              {phones}
            </ApiUiController>
          </Form>
        </Modal.Body>
      </Modal>
    );
  }
}
export default CloudCallPopup;